<nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
    <a class="navbar-brand mr-lg-5" href="../index.html">
        <img class="navbar-brand-dark" src="../volt_1.2/assets/img/brand/light.svg" alt="Volt logo" /> <img class="navbar-brand-light" src="../volt_1.2/assets/img/brand/dark.svg" alt="Volt logo" />
    </a>
    <div class="d-flex align-items-center">
        <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>

<SideBarMenu currentPage='Templates'></SideBarMenu>


<main class="content">

    <TopBarNav></TopBarNav>

<!--
            <div class="preloader bg-soft flex-column justify-content-center align-items-center">
    <img class="loader-element animate__animated animate__jackInTheBox" src="../volt_1.2/assets/img/brand/light.svg" height="60" alt="Volt logo">
</div>
-->

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                          <li class="breadcrumb-item"><a href="#"><span class="fas fa-home"></span></a></li>
                          <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                          <li class="breadcrumb-item active" aria-current="page">Templates</li>
                        </ol>
                    </nav>

                    {#if notifMsgs.length}
                    {#each notifMsgs as msg}
                    <div class="alert alert-{msg.level}" role="alert">
                        {msg.text}
                    </div>
                    {/each}
                    {/if}

                    <h2 class="h4">Templates List</h2>
                    <p class="mb-0">Define HTML templates for your channels.</p>
                </div>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <a href="/#/template/" class="btn btn-sm btn-primary"><span class="fas fa-plus mr-2"></span>New template</a>
                </div>
            </div>
            <div class="table-settings mb-4">
                <div class="row justify-content-between align-items-center">
                    <div class="col-9 col-lg-4 d-flex">
                        <div class="input-group mr-2 mr-lg-3">
                            <span class="input-group-text"><span class="fas fa-search"></span></span>
                            <input type="text" class="form-control" placeholder="Search">
                        </div>
                        <select class="form-select w-25" aria-label="Message select example 2">
                            <option selected>All</option>
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                            <option value="3">Pending</option>
                            <option value="3">Canceled</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="card card-body border-light shadow-sm table-wrapper table-responsive">
                
                <table class="table user-table table-hover align-items-center">
                    
                    <thead>
                        <tr>
                            <th class="border-bottom">Name</th>						
                            <th class="border-bottom">Created</th>
                            <th class="border-bottom">Access</th>
                            <th class="border-bottom">Status</th>
                            <th class="border-bottom">Encrypted</th>
                        </tr>
                    </thead>

                    <tbody>
                        {#each $stApp.user.templates as template}
                        <tr>
                            <td>
                                <a href="#/template/{template.uid}" class="d-flex align-items-center">
                                    <div class="d-block">
                                        <span class="font-weight-bold">{template.name}</span>
                                        <div class="small text-gray">{template.uid}</div>
                                    </div>
                                </a>
                            </td>
                            <td><span class="font-weight-normal">{dtfns_format(parseISO(template.ts_created), 'yyyy-MM-dd')} {dtfns_format(parseISO(template.ts_created), 'HH:mm')}</span></td>                        
                            <td>
                                <span class="font-weight-normal">
                                    <span>{#if template.private}private{:else}public{/if}</span>
                                </span>
                            </td>
                            <td><span class="font-weight-normal text-success">Active</span></td>
                            <td>
                            </td>
                        </tr>
                        {/each}
                    </tbody>
                </table>
                
            </div>
            
    <BottomFooter></BottomFooter>
</main>


<script>
    import {format as dtfns_format, formatISO9075, parseISO} from 'date-fns'
    import {onMount} from 'svelte'
    
    import { DBC_URL, stLang} from '../store.js'
    import {axiosPost} from '../c0utils.js'

    import {stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'

    import BottomFooter from '../comp/BottomFooter.svelte'
    import SideBarMenu from '../comp/SideBarMenu.svelte'
    import TopBarNav from '../comp/TopBarNav.svelte'

    onMount (() => {
        processAppMsgs()
    })

    let notifMsgs = []
    console.log($stApp)
    let user = new User()

    function processAppMsgs() {
        notifMsgs = $stApp.msgs
        console.log("Notifs: ", notifMsgs)
        $stApp.msgs = []
    }

    axiosPost(DBC_URL + '/user/templates', {})
    .then((result) => {
        console.log("/templates/result", result.data)
        if(result.ok) $stApp.user.templates = result.data
        console.log($stApp.user.templates)
    })

    function logout() {
        $stApp.user = {}
        push('/')
    }


</script>
